module.exports = __webpack_public_path__ + "img/support.9ce96b42.png";